import http from '../../utils/http'

const fetchSegmentsUrl = '/segments'

export const fetchSegments = () =>
  http
    .get(fetchSegmentsUrl, {
      params: { 'q[name_not_cont]': 'Não se aplica' }
    })
    .then(res => res.data)
